import React from 'react'

export function DashboardIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        stroke='currentColor'
        strokeWidth='2'
        d='M4.486 22.142l14.999-8.999M19.514 22.143l-15-9M5 3h14v10H5zM2 9h2M20 9h2M6 7h12'
      />
    </svg>
  )
}
